/** What the rail's rows need from the hover flyout (RailFlyout.tsx). */
import { createContext, useContext } from "react";
import type { TokenJob, View } from "@/api/types";

export interface FlyoutTarget {
  job: TokenJob;
  defaultView: View | undefined;
  /** the token's row, which the panel lines up with */
  row: HTMLElement;
}

export interface RailFlyout {
  /** false on touch screens and in the phone drawer: rows then take no hover handlers */
  enabled: boolean;
  /** the token whose panel is shown */
  shownId: string | null;
  enter: (target: FlyoutTarget) => void;
  leave: () => void;
  close: () => void;
}

export const RailFlyoutContext = createContext<RailFlyout>({
  enabled: false,
  shownId: null,
  enter: () => {},
  leave: () => {},
  close: () => {},
});

export const useRailFlyout = () => useContext(RailFlyoutContext);
